import { createSlice } from '@reduxjs/toolkit'
import { getUserProfileApi } from './api'
import { type IUser } from '../../../models/User'

export interface UserProfileSliceType {
  loading: boolean
  error: boolean
  user?: IUser
}

export const initialState: UserProfileSliceType = {
  loading: false,
  error: false
}

const UserProfileSlice = createSlice({
  name: 'user_profile',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUserProfileApi.pending, (state, action) => {
        state.loading = true
        state.error = false
      })
      .addCase(getUserProfileApi.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload
        state.error = false
      })
      .addCase(getUserProfileApi.rejected, (state, action) => {
        state.loading = false
        state.error = true
      })
  }
})

export default UserProfileSlice.reducer
